module.exports = __webpack_public_path__ + "img/b5b9f06.jpg";